"use client";

export interface IOrganizationLabelProps {
  organizationName: string;
  branchName: string;
  testid?: string;
}

export const OrganizationLabel = ({
  organizationName,
  branchName,
  testid = "organization-label",
}: IOrganizationLabelProps) => {
  return (
    <div
      className={
        "label-medium text-le bg-neutral-N0 border-neutral-N200 inline-flex items-center gap-2 rounded border p-2 text-sm drop-shadow"
      }
    >
      <p data-testid={`${testid}__text__organization-name`}>
        {organizationName}
      </p>
      <span>/</span>
      <p
        className={"text-purple-P700"}
        data-testid={`${testid}__text__branch-name`}
      >
        {branchName}
      </p>
    </div>
  );
};
